import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";

@Component({
    selector: 'external-redirection-confirmation-bannertemplate',
    template: `
  <div class="modelHeader">{{title}}</div>
      <div class="modal-body" ngPreserveWhitespaces>
            <p class="fs-13 pb-2">{{message}}</p>
            <p *ngIf="message1 != ''" class="fs-13 para-align">{{message1}}</p>
            <div class="text-center pt-3">
            
			  <button type="button" class="btn btn-primary" (click)="Confirm()" id="smi-confirm-btn">{{ButtonText}}</button>
              <button type="button" class="btn btn-primary" (click)="messageClose()">Cancel</button>
            </div>
      </div>
  
        `,
    styles: [
       
    ]
})
export class ExternalRedirectionConfirmationBannertemplate implements OnInit {
  title:any;
  message:any;
  message1: string = "";
  ButtonText: any;
  result: Subject<boolean> = new Subject<boolean>();
  onClose: Subject<boolean>;
    constructor(private _bsModalRef: BsModalRef) {
    }
    ngOnInit(): void {
      this.onClose = new Subject();
    }
    messageClose()
    {
      this.onClose.next(false);
      this._bsModalRef.hide();
    }
    Confirm()
    {
      this.onClose.next(true);
      this._bsModalRef.hide();
    }
}

